import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Comandă produse tipărite',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Detalii produs',
    [ProductOrderingSteps.ShippingInfo]: 'Informații livrare',
    payment: 'Plată',
  },
  form: {
    title: 'Detalii comandă',
    polygraphy_product_id: {
      label: 'Produs',
      placeholder: 'Selectați produsul',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Fluturaș - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Șablon #1 🆕',
            [FlyerTemplate.Two]: 'Șablon #2 🆕',
            [FlyerTemplate.Three]: 'Șablon #3',
            [FlyerTemplate.Four]: 'Șablon #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Autocolant - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Șablon #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Autocolant ușă - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Șablon #1 🆕',
            [DoorStickerTemplate.Two]: 'Șablon #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Cantitate',
      placeholder: 'Introduceți cantitatea',
    },
    service_level: {
      label: 'Nivel de serviciu',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Economic',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Companie',
      placeholder: 'Introduceți numele companiei',
    },
    shipping_salutation: {
      label: 'Salut',
      options: {
        mr: 'Dl',
        mrs: 'Dna',
      },
    },
    shipping_first_name: {
      label: 'Prenume',
      placeholder: 'Introduceți prenumele',
    },
    shipping_last_name: {
      label: 'Nume',
      placeholder: 'Introduceți numele',
    },
    shipping_country: {
      label: 'Țară',
      placeholder: 'Selectați țara',
    },
    shipping_state: {
      label: 'Județ/Stat',
      placeholder: 'Selectați județ/stat',
    },
    shipping_city: {
      label: 'Oraș',
      placeholder: 'Introduceți orașul',
    },
    shipping_address: {
      label: 'Adresă',
      placeholder: 'Introduceți adresa',
    },
    shipping_zip_code: {
      label: 'Cod poștal',
      placeholder: 'Introduceți codul poștal',
    },
    shipping_phone_number: {
      label: 'Număr de telefon',
      placeholder: 'Introduceți numărul de telefon',
    },
    create_invoice: {
      options: {
        true: 'Facturare automată – Plată imediată',
        false: 'Trimite gratuit – Este un cadou',
      },
    },
  },
  table: {
    title: 'Comenzi anterioare',
    fields: {
      product: 'Produs',
      quantity: 'Cantitate',
      status: 'Status',
      service_level: 'Nivel de serviciu',
      shipping: 'Livrare',
      tracking_url: 'URL urmărire',
      created: 'Creat',
      updated: 'Ultima actualizare',
    },
  },
  labels: {
    shipping_company: 'Companie',
    shipping_salutation: 'Salut',
    shipping_first_name: 'Prenume',
    shipping_last_name: 'Nume',
    shipping_address: 'Adresă',
    shipping_zip_code: 'Cod poștal',
    shipping_city: 'Oraș',
    shipping_phone_number: 'Număr de telefon',
    show_shipping_details: 'Detalii livrare',
    track_order: 'Urmărire comandă',
    pending_from_provider: 'În așteptare de la furnizor',
  },
  modals: {
    confirmation: {
      title: 'Confirmați detaliile comenzii',
    },
    free_order_confirmation: {
      title: 'Sigur doriți să trimiteți {{product}} gratuit?',
      description: 'Ați ales să nu percepeți nicio taxă clientului astăzi.\n Produsul va fi expediat fără plată.',
      buttons: {
        confirm: 'Da, trimite gratuit',
      },
    },
  },
  buttons: {
    back_to_templates: 'Înapoi la șabloane',
    preview: 'Previzualizare',
    next: 'Înainte',
    order: 'Creează comandă',
    confirm: 'Confirmă',
  },
  feedback: {
    shop_url_used: 'Produsul include URL-ul magazinului online (<url>{{url}}</url>). Este intenționat?',
    order_total_price: 'Preț total pentru produsele selectate: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Eroare la crearea comenzii',
    order_got_created: 'Comanda a fost creată',
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
